import React from 'react';
import './App.css';

export default function WelcomeModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, width: '100vw', height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      backdropFilter: 'blur(6px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'var(--bg-panel)',
        border: '1px solid #D4AF37',
        borderRadius: '16px',
        maxWidth: '750px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        padding: '35px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.6)',
        color: 'var(--text-main)',
        boxSizing: 'border-box'
      }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '25px' }}>
          <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '28px', color: '#D4AF37', marginBottom: '8px' }}>
            🚀 Welcome to VYODHA Institutional Terminal
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '13px', margin: 0 }}>
            Knowledge First. Discipline Always. Trade Better. Aapke trading safar ko asan aur professional banane ke liye kuch zaroori features:
          </p>
        </div>

        {/* Feature List Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px', marginBottom: '30px' }}>
          
          <div style={{ backgroundColor: 'var(--bg-main)', padding: '15px', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
            <h4 style={{ color: '#D4AF37', fontSize: '15px', marginBottom: '5px' }}>🛡️ AI Risk Guardian</h4>
            <p style={{ color: 'var(--text-muted)', fontSize: '12px', margin: 0 }}>Aapke capital aur drawdown ko monitor karta hai taaki overtrading se bacha ja sake.</p>
          </div>

          <div style={{ backgroundColor: 'var(--bg-main)', padding: '15px', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
            <h4 style={{ color: '#D4AF37', fontSize: '15px', marginBottom: '5px' }}>📊 Option Chain & Greeks</h4>
            <p style={{ color: 'var(--text-muted)', fontSize: '12px', margin: 0 }}>Live OI build-up, Delta, Theta, aur Vega analyze karke big players ka rukh pehchanein.</p>
          </div>

          <div style={{ backgroundColor: 'var(--bg-main)', padding: '15px', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
            <h4 style={{ color: '#D4AF37', fontSize: '15px', marginBottom: '5px' }}>📐 Strategy Builder</h4>
            <p style={{ color: 'var(--text-muted)', fontSize: '12px', margin: 0 }}>Iron Condor ya Spreads banayein aur deploy karne se pehle Max Profit/Loss dekhein.</p>
          </div>

          <div style={{ backgroundColor: 'var(--bg-main)', padding: '15px', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
            <h4 style={{ color: '#D4AF37', fontSize: '15px', marginBottom: '5px' }}>⚡ Algo Bot & Trailing</h4>
            <p style={{ color: 'var(--text-muted)', fontSize: '12px', margin: 0 }}>TradingView webhooks ke zariye automatic signals run karein aur trailing stop-loss use karein.</p>
          </div>

        </div>

        {/* Action Button */}
        <div style={{ textAlign: 'center' }}>
          <button onClick={onClose} style={{
            backgroundColor: '#D4AF37',
            color: '#000',
            border: 'none',
            padding: '14px 35px',
            borderRadius: '10px',
            fontSize: '15px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(212, 175, 55, 0.4)'
          }}>
            Explore Terminal 🚀
          </button>
        </div>

      </div>
    </div>
  );
}